<template>
    <transition name="fade">
        <div v-if="show" class="alert alert-info">
            <button v-if="btnClose" type="button" class="close"
                    @click="closeMe()"><span aria-hidden="true">&times;</span></button>
            <div v-if="obj">
                <div v-if="isHtml" v-for="lbl in label" v-html="lbl"></div>
                <!-- v-else not working here -->
                <div v-if="!isHtml" v-for="lbl in label"><span class="glyphicon glyphicon-info-sign"
                                                               aria-valuemin="true"></span> {{ lbl }}</div>
            </div>
            <div v-else>
                <span class="glyphicon glyphicon-info-sign" aria-valuemin="true"></span> {{ label }}
            </div>
        </div>
    </transition>
</template>

<script>

    export default {
        props: ['show', 'label', 'btnClose', 'isHtml'],
        computed: {
            obj: function(){
                if(!this.label) {
                    return false;
                }
                return (Array.isArray(this.label)) ? true : false;
            }
        },
        methods: {
            closeMe: function(){
                this.$emit('closeAlertInfo');
            }
        }
    }
</script>

<style scoped>
    ul {
        padding: 0;
        list-style: none;
    }
</style>


// WEBPACK FOOTER //
// BanetInfo.vue?6b4c1ca3